import script from "./Heard.vue?vue&type=script&setup=true&lang=js"
export * from "./Heard.vue?vue&type=script&setup=true&lang=js"

import "./Heard.vue?vue&type=style&index=0&id=1d4cc3e5&lang=scss&scoped=true"

import exportComponent from "/Users/kexikui/Desktop/code/dlmk/dlmk-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4cc3e5"]])

export default __exports__